import { isPageOpenRecoveryError } from "@/lib/posthogExceptions";

export type FatalErrorCopy = {
  body: string;
  title: string;
};

const GENERIC_FATAL_COPY: FatalErrorCopy = {
  body: "Please reload the page. If this keeps happening, contact support.",
  title: "An unexpected error occurred.",
};

// A page-open recovery error (failed lazy chunk / missing provider context)
// only reaches the fatal screen once attemptClientReloadRecovery has already
// spent MAX_RELOAD_ATTEMPTS_PER_BUILD reloads on it — see reloadRecovery.ts.
// In prod these are spread across routes and users on mobile Safari/Chrome
// (~20 events, ~4 users a day, flat for weeks), i.e. flaky fetches of hashed
// chunks rather than a broken deploy. "An unexpected error occurred." reads
// as an app fault and points at support; the user's actual next step is to
// check their connection and retry.
const PAGE_OPEN_RECOVERY_FATAL_COPY: FatalErrorCopy = {
  body: "This is usually a network problem. Check your connection and try again.",
  title: "The app couldn't finish loading.",
};

export const getFatalErrorCopy = (error: unknown): FatalErrorCopy =>
  isPageOpenRecoveryError(error)
    ? PAGE_OPEN_RECOVERY_FATAL_COPY
    : GENERIC_FATAL_COPY;
